module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-45.40d25d53.png";